import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from 'react-router-dom';
import { getStudentDetailsByAdmission, resetGetStudentDetailsByAdmissionDetailsState, updateOrderStatus } from "../../redux/features/student/studentSlice";
import { apiSaveAuditLogs, apiUpdateOrderDetails, resetCreateOrderState } from "../../redux/features/payment/payment.order.slice";
import { razorpayKey, razorpaySecret } from "../../config/config";
import AppContext from "../../storage/AppContext";

const RazorPay = ({ match ,location}) => {

    const dispatch = useDispatch()

    const [theArray, setTheArray] = useState({});

    const [shouldNavigate,setShouldNavigate] = useState(false)

    const { admId, academicYear } = useParams()

    let searchQuery=window.location.search

    let redirectPage=searchQuery.split("=")[1]

    let navigate = useNavigate();

    const orderDetails = useSelector(state => state.createOrder)

    const updatedDetails = orderDetails.updatePaymentDetails

    const userDetails = useSelector(state => state.student)

    const details = userDetails.getStudentDetailsByAdmissionDetails

    const payeeDetails = details?.data

    console.log("payment page")
    const appContext = useContext(AppContext);

    const adminDetails = appContext?.userDetails

    useEffect(() => {
        if (details.status === "succeeded" && payeeDetails) {
            setTheArray([])
            payeeDetails?.termFee?.map((eachItem) => {
                if (Object.keys(eachItem)[0] === payeeDetails?.receipt) {
                    setTheArray(eachItem[payeeDetails?.receipt])
                }
            })
        }
    }, [details.status])

    useEffect(() => {
        if(orderDetails.order.status === 'succeeded'){
            dispatch(getStudentDetailsByAdmission({
                admission: admId,
                academicYear
            }))
        }
    }, [orderDetails.order.status])

    useEffect(() => {
        if (redirectPage === "native") {
            dispatch(getStudentDetailsByAdmission({
                admission: admId,
                academicYear
            }))
        }
    }, [redirectPage])

    useEffect(() => {
        if (shouldNavigate) {
            setTheArray({})
            if(redirectPage==="native"){
                navigate(`/nativePaymentStatus/${admId}/${academicYear}`, { replace: true })
            }else{
                navigate(`/paymentStatus/${admId}/${academicYear}`, {replace : true})
            }
        }

    }, [shouldNavigate])

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    const displayRazorpay = async () => {
        // const res = await loadScript("https://api.razorpay.com/v1/checkout/embedded");
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }
        let paymentObject
        const options = {
            // key: "rzp_test_4ooZqGtgtcJpfl",
            // key_secret: "PHqqPRAeJ2AVlkwq0nVIP0rI",
           
            // key: 'rzp_test_sqNxwNoHPVS5c0',
            // key_secret: 'CUOhlURnP5abO40zUFZ30mOB',

            // key: 'rzp_live_zdLen5i4S2GX08',
            // key_secret: 'ek6dSNO2VvHbKpuikxKYK70a',

            key: razorpayKey,
            key_secret: razorpaySecret,

            amount: ((theArray.discountedAmount && theArray.discountedAmount !== "NA" && theArray.discountedAmount !== "Pending" && theArray.discountedAmount !== "Rejected") ? theArray.discountedAmount : theArray.amount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            order_id: theArray.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            currency: "INR",
            name: "SVBK",
            description: payeeDetails.receipt,
            handler: function (response) { 
                console.log("success response of handler in razorpay",response)
                setShouldNavigate(true)
                // dispatch(apiUpdateOrderDetails({
                //     signature: response.razorpay_signature,
                //     ADMISSION: payeeDetails.admissionNumber,
                //     receipt: payeeDetails.receipt,
                //     paymentStatus: "Paid",
                //     transactionId: response.razorpay_payment_id,
                //     orderId: theArray.orderId,
                //     paidAmount: ((theArray.discountedAmount && theArray.discountedAmount !== "NA" && theArray.discountedAmount !== "Pending" && theArray.discountedAmount !== "Rejected") ? theArray.discountedAmount : theArray.amount)
                // }))

                // dispatch(apiSaveAuditLogs({
                //     orderId: response.razorpay_order_id,
                //     transactionId: response.razorpay_payment_id,
                //     name: payeeDetails.name,
                //     email: payeeDetails.email,
                //     admissionNumber: payeeDetails.admissionNumber,
                //     term: payeeDetails.receipt,
                //     branch:adminDetails?.data?.branch
                // }))
                
            },
            modal: {
                "ondismiss": function () {
                    navigate("/admission")
                    dispatch(resetCreateOrderState())
                    dispatch(resetGetStudentDetailsByAdmissionDetailsState())
                }
            },
            prefill: {
                name: redirectPage !== "native"? "":payeeDetails.name,
                email: redirectPage !== "native"? "":payeeDetails.email,
                contact: redirectPage !== "native"? "":payeeDetails.phoneNumber,
            },
            // timeout: 480,
            // retry:{
            //     enabled: false
            // }
        };

        const _window = window;
        paymentObject = new _window.Razorpay(options);
        paymentObject.on('payment.failed', function (response) {
            // console.log("failure response of handler in razorpay",response)
            // setShouldNavigate(true)
            // setTheArray({})
            // if(redirectPage==="native"){
            //     navigate(`/nativePaymentStatus/${admId}`, { replace: true })
            // }else{
            //     navigate(`/paymentStatus/${admId}`, {replace : true})
            // }
            // dispatch(apiUpdateOrderDetails({
            //     signature: response.razorpay_signature,
            //     ADMISSION: payeeDetails.admissionNumber,
            //     receipt: payeeDetails.receipt,
            //     paymentStatus: "Unpaid",
            //     transactionId: response.error.metadata.payment_id,
            //     orderId: theArray.orderId,
            // }))

            // dispatch(apiSaveAuditLogs({
            //     orderId:response.error.metadata.order_id,
            //     transactionId: response.error.metadata.payment_id,
            //     name: payeeDetails.name,
            //     email: payeeDetails.email,
            //     admissionNumber: payeeDetails.admissionNumber,
            //     term:payeeDetails.receipt,
            //     branch:adminDetails?.data?.branch
            // }))
        })
        paymentObject.open();
    };

    useEffect(() => {
        if (details.status === "succeeded" && Object.keys(theArray).length) {
            dispatch(updateOrderStatus("idle"))
            displayRazorpay()
        }
    }, [details.status, theArray])

    return (
        <div>
            {details.status === "succeeded" ? null : (
                <div className="d-flex justify-content-center align-items-center "
                    style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p style={{ fontSize: 20 }}>Please wait while we redirect.....</p>
                </div>
            )}
        </div>
    )
}

export default RazorPay
